// Timestamp relativo con el ISO absoluto en tooltip. Acepta ISO string o
// epoch seconds (el backend mezcla ambos según la fuente Aurora/Dynamo).

import { useI18n } from '@/lib/i18n';

const UNITS: [number, Intl.RelativeTimeFormatUnit][] = [
  [60, 'second'],
  [60, 'minute'],
  [24, 'hour'],
  [365, 'day'],
];

const rtfCache = new Map<string, Intl.RelativeTimeFormat>();

export function formatAgo(ms: number, lang: string): string {
  let rtf = rtfCache.get(lang);
  if (!rtf) {
    rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto', style: 'short' });
    rtfCache.set(lang, rtf);
  }
  let delta = (ms - Date.now()) / 1000;
  for (const [step, unit] of UNITS) {
    if (Math.abs(delta) < step) return rtf.format(Math.round(delta), unit);
    delta /= step;
  }
  return rtf.format(Math.round(delta), 'year');
}

export function TimeAgo({ value }: { value: string | number | null }) {
  const { lang } = useI18n();
  if (value === null || value === 0) return <span className="text-ink-subtle">—</span>;
  const ms = typeof value === 'number' ? value * 1000 : Date.parse(value);
  if (Number.isNaN(ms)) return <span className="text-ink-subtle">—</span>;
  return (
    <time title={new Date(ms).toISOString()} className="whitespace-nowrap tabular-nums">
      {formatAgo(ms, lang)}
    </time>
  );
}
